// extracted by mini-css-extract-plugin
export default {"colorPicker":"stencil-tools_colorPicker__EcUCc"};